"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighCircles = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
const Turmoil_1 = require("../../turmoil/Turmoil");
const Size_1 = require("../render/Size");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Card_1 = require("../Card");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class HighCircles extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.HIGH_CIRCLES,
            tr: { tr: 1 },
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'P51',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(1).cards(1).asterix().nbsp(Size_1.Size.SMALL).delegates(2);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('You have +1 influence.', (eb) => {
                            eb.startEffect.plus().influence(1);
                        });
                    });
                }),
                description: 'Raise your TR 1 step and draw 1 card with a PARTY REQUIREMENT. Place 2 delegates in one party.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.getDelegatesInReserve(player.id) < 2)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const title = 'Select where to send two delegates';
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        turmoil.addInfluenceBonus(player);
        player.increaseTerraformRating();
        player.drawCard(1, {
            include: (card) => { var _a; return ((_a = card.requirements) === null || _a === void 0 ? void 0 : _a.hasParty()) === true; },
        });
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, title, { count: 2, source: 'reserve' }));
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 1 });
    }
}
exports.HighCircles = HighCircles;
//# sourceMappingURL=HighCircles.js.map